import { useCallback, useRef } from 'react';

const DEFAULT_DELAY_MS = 400;

export function useLongPress(
  onLongPress: (e: React.TouchEvent, payload: number) => void,
  delayMs = DEFAULT_DELAY_MS
) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const payloadRef = useRef<number>(0);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const onTouchStart = useCallback(
    (e: React.TouchEvent, payload: number) => {
      payloadRef.current = payload;
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
        onLongPress(e, payloadRef.current);
      }, delayMs);
    },
    [onLongPress, delayMs]
  );

  const onTouchEnd = useCallback(() => {
    clearTimer();
  }, [clearTimer]);

  const onTouchCancel = useCallback(() => {
    clearTimer();
  }, [clearTimer]);

  return { onTouchStart, onTouchEnd, onTouchCancel };
}
